import React, { useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { get_card_products, delete_card_product, messageClear, quantity_inc, quantity_dec } from "../store/reducers/cardReducer";
import toast from "react-hot-toast";
import useGuestId from "../hooks/useGuestId";
import CheckoutStepper from "../components/CheckoutStepper";

const originUrl = window.location.origin;
const bgStyle = {
  backgroundImage: `url(${originUrl}/images/banner/shop.png)`,
};

const Card = () => {
  const dispatch = useDispatch();

  const { currentCompany } = useSelector(state => state.init);
  const { userInfo } = useSelector(state => state.auth);
  const guestId = useGuestId(); // Usamos el hook
  const { card_products, successMessage, price, buy_product_item, outofstock_products } = useSelector(state => state.card);

  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      dispatch(get_card_products(userInfo.id));
    } else if (guestId) {
      dispatch(get_card_products(guestId));
    }
  }, [dispatch, userInfo, guestId]);

  const redirect = () => {
    navigate("/envio", {
      state: {
        products: card_products,
        price: price,
        items: buy_product_item,
      },
    });
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      if (userInfo) {
        dispatch(get_card_products(userInfo.id));
      } else if (guestId) {
        dispatch(get_card_products(guestId));
      }
    }
  }, [dispatch, successMessage, userInfo, guestId]);

  const inc = (quantity, stock, card_id) => {
    const temp = quantity + 1;
    if (temp <= stock) {
      dispatch(quantity_inc(card_id));
    } else {
      toast.error("Stock Agotado");
    }
  };

  const dec = (quantity, card_id) => {
    const temp = quantity - 1;
    if (temp !== 0) {
      dispatch(quantity_dec(card_id));
    }
  };

  return (
    <div>
      <Header />
      {currentCompany?.verimageCarrito && (
        <section className="h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left" style={bgStyle}>
          <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
              <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
                <h2 className="text-3xl font-bold">Carrito </h2>
                <div className="flex justify-center items-center gap-2 text-2xl w-full">
                  <Link to="/">Inicio</Link>
                  <span className="pt-1">
                    <IoIosArrowForward />
                  </span>
                  <span>Carrito </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="bg-[#eeeeee]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16">
          {currentCompany?.verCheckoutStepper && <CheckoutStepper currentStep={1} />}
          {card_products.length > 0 || outofstock_products > 0 ? (
            <div className="flex flex-wrap">
              <div className="w-[67%] md-lg:w-full">
                <div className="pr-3 md-lg:pr-0">
                  <div className="flex flex-col gap-3">
                    <div className="bg-white p-4">
                      <h2 className="text-md text-[#ae1d22] font-semibold">Productos en stock {card_products[0].products.length}</h2>
                    </div>
                    {card_products.map((p, i) => (
                      <div className="flex bg-white p-4 flex-col gap-2">
                        <div className="flex justify-start items-center">
                          <h2 className="text-md text-slate-600 font-bold">{p.shopName}</h2>
                        </div>
                        {p.products.map((pt, i) => (
                          <div className="w-full flex flex-wrap">
                            <div className="flex sm:w-full gap-2 w-7/12">
                              <div className="flex gap-2 justify-start items-center">
                                <img className="w-[80px] h-[80px]" src={pt.productInfo.image} alt="" />

                                <div className="pr-4 text-slate-600">
                                  <p className="text-85 font-semibold">
                                    {pt.productInfo.name}
                                    {pt.variant?.size && ` - Talla: ${pt.variant.size}`}
                                  </p>

                                  <span className="text-sm">Marca: {pt.productInfo.brand}</span>
                                </div>
                              </div>
                            </div>

                            <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                              <div className="pl-4 sm:pl-0">
                                <h2 className="text-lg text-orange-500">S/{pt.productInfo.discount > 0 ? pt.productInfo.discount : pt.productInfo.price}</h2>
                                {pt.productInfo.discount > 0 && <p className="line-through">S/{pt.productInfo.price}</p>}
                                {pt.productInfo.discount > 0 && <p>{Math.round(((pt.productInfo.price - pt.productInfo.discount) / pt.productInfo.price) * 100)}%</p>}
                              </div>
                              <div className="flex gap-2 flex-col">
                                <div className="flex bg-slate-200 h-[30px] justify-center items-center text-xl">
                                  <div onClick={() => dec(pt.quantity, pt._id)} className="px-3 cursor-pointer">
                                    -
                                  </div>
                                  <div className="px-3">{pt.quantity}</div>
                                  <div onClick={() => inc(pt.quantity, pt.productInfo.stock, pt._id)} className="px-3 cursor-pointer">
                                    +
                                  </div>
                                </div>
                                <button onClick={() => dispatch(delete_card_product(pt._id))} className="px-5 py-[3px] bg-red-500 text-white">
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}

                    {outofstock_products.length > 0 && (
                      <div className="flex flex-col gap-3">
                        <div className="bg-white p-4">
                          <h2 className="text-md text-red-500 font-semibold">Agotado {outofstock_products.length}</h2>
                        </div>

                        <div className="bg-white p-4">
                          {outofstock_products.map((p, i) => (
                            <div className="w-full flex flex-wrap">
                              <div className="flex sm:w-full gap-2 w-7/12">
                                <div className="flex gap-2 justify-start items-center">
                                  <img className="w-[80px] h-[80px]" src={p.products.image} alt="" />
                                  <div className="pr-4 text-slate-600">
                                    <h2 className="text-md font-semibold">{p.products.name} </h2>
                                    <span className="text-sm">Marca: {p.products.brand}</span>
                                  </div>
                                </div>
                              </div>

                              <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                                <div className="pl-4 sm:pl-0">
                                  <h2 className="text-lg text-orange-500">S/{p.products.discount > 0 ? p.products.discount : p.products.price}</h2>
                                  {p.products.discount > 0 && <p className="line-through">S/{p.products.price}</p>}
                                  <p>{Math.round((p.products.discount / (p.products.price + p.products.discount)) * 100)}%</p>
                                </div>
                                <div className="flex gap-2 flex-col">
                                  <div className="flex bg-slate-200 h-[30px] justify-center items-center text-xl">
                                    <div onClick={() => dec(p.quantity, p._id)} className="px-3 cursor-pointer">
                                      -
                                    </div>
                                    <div className="px-3">{p.quantity}</div>
                                    <div className="px-3 cursor-pointer">+</div>
                                  </div>
                                  <button onClick={() => dispatch(delete_card_product(p._id))} className="px-5 py-[3px] bg-red-500 text-white">
                                    Eliminar
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="w-[33%] md-lg:w-full">
                <div className="pl-3 md-lg:pl-0 md-lg:mt-5">
                  {card_products.length > 0 && (
                    <div className="bg-white p-3 text-slate-600 flex flex-col gap-3">
                      <h2 className="text-xl font-bold">Resumen del pedido</h2>
                      <div className="flex justify-between items-center">
                        <span>
                          {buy_product_item} {buy_product_item === 1 ? "producto" : "productos"}{" "}
                        </span>
                        <span>S/{price} </span>
                      </div>

                      <div className="flex gap-2">
                        <input className="w-full px-3 py-2 border border-slate-200 outline-0 focus:border-green-500 rounded-sm" type="text" placeholder="Ingresar cupón de descuento" />
                        <button className="px-5 py-[1px] bg-[#ae1d22] text-white rounded-sm uppercase text-sm">Aplicar</button>
                      </div>

                      <div className="flex justify-between items-center">
                        <span>Total</span>
                        <span className="text-lg text-[#ae1d22]">S/{price} </span>
                      </div>
                      <button onClick={redirect} className="px-5 py-[6px] rounded-sm hover:shadow-red-500/50 hover:shadow-lg bg-red-500 text-sm text-white uppercase ">
                        CONTINUAR ({buy_product_item} {buy_product_item === 1 ? "producto" : "productos"} )
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Link className="px-4 py-1 bg-indigo-500 text-white" to="/shops">
                {" "}
                Compra ahora
              </Link>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default Card;
